module.exports = __webpack_public_path__ + "img/mb-outdoors.2252c87c.png";